exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.stepper {\n    width: 50px;\n    padding: 3px 5px;\n    text-align: center;\n    /*height: 30px;*/\n    border: 1px solid #C0C0C0;\n    display: inline-block;\n}\n.upq-add-to-cart-btn:hover,\n.upq-add-to-cart-btn:active {\n    background-color: #fcd900;\n}\n", ""]);

// exports
